import { Component, OnInit } from '@angular/core';
import { JeevesAddOrderRowModalComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'cult-add-order-row-modal',
    templateUrl: './cult-add-order-row-modal.component.html',
    styleUrls: ['./cult-add-order-row-modal.component.scss'],
    standalone: false
})
export class CultAddOrderRowModalComponent extends JeevesAddOrderRowModalComponent implements OnInit {}
